/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiOrderIc.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-order-ic";

export class AutogenModelEdiOrderIc<RowType extends ModelRow> extends Endpoint<RowType, RowEdiOrderIcFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiOrderIc extends ModelRow<RowEdiOrderIcFields> {
	constructor(values?: Partial<RowEdiOrderIcFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiOrderIcFields {
	brokerage_sequence: string;
	company_id: string;
	direction: string;
	intercompany: string;
	intercompany_key: string;
	move_status: string;
	movement_id: string;
	order_id: string;
	original_order: string;
	reply_received: string;
	reply_status: string;
	role: string;
	settled_date: string;
	shared_company: string;
	shared_order_id: string;
	shared_shipment_id: string;
	submitted_date: string;
}
